<template>
	<div v-if="dataSource" class="list-item" @click="onClick">
		<img src="../../../assets/img-v2/ic_search_station.png" class="icon" />
		<div class="content">
			<div class="row">
				<div class="left">
					<div class="title" v-html="getTitleHtml()"></div>
					<div v-if="poiType === 'on' && index === 0" class="btn">离你最近</div>
				</div>
				<div class="distance" v-show="dataSource.distance">{{dataSource.distanceText}}{{dataSource.distanceUnit}}</div>
			</div>
			<div class="address">
				<div v-if="dataSource.type === 0">{{dataSource.address}}</div>
				<template v-if="dataSource.type === 3 || dataSource.type === 1">
					<span class="tag" v-for="(addr, i) in dataSource.address" :key="i">{{addr}}</span>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'poiAutocompleteCard',
	props: {
		dataSource: {
			type: Object
		},
    poiType: {
      type: String
    },
		index: {
			type: Number,
			default: -1
		}
	},
	methods: {
		getTitleHtml() {
			const {name, keyword} = this.dataSource || {};
			if (!keyword) {
				return name;
			}
			return name.replace(new RegExp(keyword, 'gim'), `<span class="highlight">${keyword}</span>`);
		},
		onClick() {
			this.$emit('click', this.dataSource);
		}
	}
};
</script>

<style scoped lang="scss">
	.list-item {
		width: calc(100% - 28px);
		display: flex;
		padding: 14px 0;
		margin-left: 14px;
    position: relative;
		&:not(:last-child) {
			border-bottom: 1px solid #eeeeee;
		}
		.icon {
			width: 20px;
			height: 20px;
			margin-right: 8px;
		}
		.content {
			flex: 1;
		}
		.row {
			display: flex;
			flex-direction: row;
			align-items: flex-start;
			justify-content: space-between;
			.title {
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 14px;
				color: #000000;
				line-height: 20px;
				text-align: left;
				font-style: normal;
			}
			.distance {
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 14px;
				color: #999999;
				line-height: 20px;
				text-align: right;
				font-style: normal;
				white-space: nowrap;
				margin-left: 12px;
			}
		}
		.address {
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 14px;
			color: #666666;
			line-height: 20px;
			text-align: left;
			font-style: normal;
			display: flex;
			align-items: flex-start;
			flex-wrap: wrap;
			margin-top: 2px;
		}

		.tag {
			height: 16px;
			display: inline-flex;
			align-items: center;
			background: #EBF4FF;
			border-radius: 4px;
			padding: 0 4px;
			white-space: nowrap;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 11px;
			color: #006EFA;
			text-align: left;
			font-style: normal;
			margin: 6px 4px 0 0;
		}
		::v-deep .highlight {
			color: #1792FF;
		}
	}
	.left {
		display: flex;
	}
	.btn {
			height: 20px;
			display: flex;
			align-items: center;
			padding: 0 4px;
			background: #EBFFF9;
			border-radius: 4px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 12px;
			color: #04B47C;
			line-height: 16px;
			text-align: left;
			font-style: normal;
			white-space: nowrap;
			margin-left: 8px;
		}
</style>
